var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 46,
    viewBox: "0 0 68 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.7047 22.9319L64.1325 7.79059V37.9004L46.7047 22.9319ZM24.2477 25.4961L30.3677 30.8086C31.3282 31.6246 32.5805 32.1176 33.949 32.1176H33.9972H34.034C35.4053 32.1176 36.6577 31.6218 37.6295 30.8001L37.621 30.8058L43.741 25.4933L62.3447 41.4704H5.6525L24.2477 25.4961ZM5.627 4.20075H62.3787L35.1192 27.8761C34.8127 28.1185 34.4333 28.2503 34.0425 28.2501H34.0028H33.966C33.5738 28.2506 33.1932 28.1177 32.8865 27.8733L32.8893 27.8761L5.627 4.20075ZM3.8675 7.78775L21.2925 22.9291L3.8675 37.8891V7.78775ZM65.0675 0.871585C64.3875 0.531585 63.5885 0.333252 62.7413 0.333252H5.26717C4.44596 0.333448 3.63603 0.524532 2.90133 0.891419L2.9325 0.877252C2.05296 1.31107 1.31225 1.98219 0.794054 2.81481C0.275855 3.64744 0.000814153 4.60838 0 5.58909L0 40.0764C0.00149998 41.4721 0.556615 42.8103 1.54354 43.7972C2.53047 44.7841 3.86861 45.3393 5.26433 45.3408H62.7328C64.1286 45.3393 65.4667 44.7841 66.4536 43.7972C67.4406 42.8103 67.9957 41.4721 67.9972 40.0764V5.58909C67.9972 3.52925 66.81 1.74425 65.0817 0.885752L65.0505 0.871585H65.0675Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5664873b7e87355193e9f1c364c2a542.svg";
export { ForwardRef as ReactComponent };